var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.047 15.997a3.067 3.067 0 011.04-2.305L21.956.612a2.462 2.462 0 013.25 3.697L12.205 15.75a.334.334 0 000 .5l13.003 11.44a2.463 2.463 0 01-3.252 3.697L7.09 18.31A3.079 3.079 0 016.046 16z"
  })));
}
export default SvgArrowLeft;